import axios from "./axiosService";
import services from "./base";
import { serviceResponseSuccess, serviceResponseError } from "./common";

const dashboardService = {
    getExpedientesCount: async (fechaInicio, fechaFin) => {
        try {
            const response = await axios.get(`${services.urlReporting}/expedientes-count?fechaInicio=${fechaInicio}&fechaFin=${fechaFin}`);
            return serviceResponseSuccess(response.data);
        } catch (error) {
            return serviceResponseError(error.message);
        }
    },

    getTop5UpcomingDates: async () => {
        try {
            const response = await axios.get(`${services.urlReporting}/top5-dates`);
            return serviceResponseSuccess(response.data);
        } catch (error) {
            return serviceResponseError(error.message);
        }
    },

    getTop5InactiveFiles: async () => {
        try {
            const response = await axios.get(`${services.urlReporting}/top5-inactive-files`);
            return serviceResponseSuccess(response.data);
        } catch (error) {
            return serviceResponseError(error.message);
        }
    },

    getTop5InactiveFilesSent: async () => {
        try {
            const response = await axios.get(`${services.urlReporting}/top5-inactive-files-sent`);
            return serviceResponseSuccess(response.data);
        } catch (error) {
            return serviceResponseError(error.message);
        }
    },

    getFilesCreatedStats: async () => {
        try {
            const response = await axios.get(`${services.urlReporting}/expedientes-created-stats`);
            return serviceResponseSuccess(response.data);
        } catch (error) {
            return serviceResponseError(error.message);
        }
    },

    getFilesFinishedStats: async () => {
        try {
            const response = await axios.get(`${services.urlReporting}/expedientes-finished-stats`);
            return serviceResponseSuccess(response.data);
        } catch (error) {
            return serviceResponseError(error.message);
        }
    },

    getFilesCreatedMonthly: async () => {
        try {
            const response = await axios.get(`${services.urlReporting}/expedientes-created-monthly`);
            return serviceResponseSuccess(response.data);
        } catch (error) {
            return serviceResponseError(error.message);
        }
    },

    getFeeStats: async () => {
        try {
            const response = await axios.get(`${services.urlReporting}/fee-stats`);
            return serviceResponseSuccess(response.data);
        } catch (error) {
            return serviceResponseError(error.message);
        }
    },
};

export default dashboardService;
